import { LongRunningContextCategoryTyp } from 'src/app/samwebDescription/samweb/waitingContext/waitingContextCategory';
import { EmailPurpose } from 'src/app/samwebDescription/samwin/EmailPurpose';
import { LongRunningAction } from 'src/app/store/server-communication/running-actions/types/longRunningAction.decorator';
import { EmailTemplateShortInfoRemoteDto } from 'src/generated/signalR/email-template-short-info-remote-dto';
import { DirectoryEmailContact, PagingInfoRemoteDto } from 'src/generated/swagger';

@LongRunningAction(LongRunningContextCategoryTyp.GLOBAL)
export class StartEmailProcess {
   public static readonly type = '[EmailDialog] Start Email Process';

   constructor(public purpose: EmailPurpose, public contextData?: any) {}
}

export class ChangeEditorToReader {
   public static readonly type = '[EmailDialog] Change editor to reader';

   constructor(public messageId: string) {}
}

export class ChangeReaderToEditor {
   public static readonly type = '[EmailDialog] Change reader to editor';

   constructor(public messageId: string, public skillId: number, public purpose: EmailPurpose, public contextData?: any) {}
}

export class SendEmailProcess {
   public static readonly type = '[EmailDialog] Send Email';

   constructor(public messageId: string) {}
}

export class EndEmailProcess {
   public static readonly type = '[EmailDialog] End Email';

   constructor(public messageId: string) {}
}

export class EmailTemplateSelected {
   public static readonly type = '[EmailDialog] Select Template';

   constructor(public template: EmailTemplateShortInfoRemoteDto, public messageId: string) {}
}

export class QueueSelectionSearchTextChanged {
   public static readonly type = '[EmailDialog] Search Text Changed';

   constructor(public searchText: string) {}
}

export class QueryDirectoryEmails {
   public static readonly type = '[EmailDialog] Query Directory Mail';

   constructor(public messageId: string, public searchTerms: string, public sortByDescending: boolean, public pagingInfo: PagingInfoRemoteDto) {}
}

export class UpdateDirectoryEmails {
   public static readonly type = '[EmailDialog] Update Directory Mail ';

   constructor(public messageId: string, public emails: DirectoryEmailContact[]) {}
}
